<script setup lang="ts">
    const { product } = defineProps<{ product: Product }>()
</script>

<template>
    <div>
        {{ product.product_variants ? product.product_variants.options[0].price : product.price }}
    </div>
</template>
